import { gql, useQuery } from '@apollo/client';

export const GET_PROJECT_ROLE_REFERENCED_STATUS_IN_PROJECT_RATE_TABLE = gql`
  query GetProjectRoleReferencedStatusInProjectRateTable(
    $projectId: String!
    $input: ProjectRoleRateTableReferenceStatusInput!
  ) {
    project(projectId: $projectId) {
      id
      getProjectRoleReferencedStatusInProjectRateTable(input: $input) {
        roleUri
        isReferenced
      }
    }
  }
`;

export const useGetProjectRoleReferencedStatusInProjectRateTable = ({
  projectId,
  roleUri,
  taskUri,
  resourceEstimateSummary
}) => {
  const { data, loading } = useQuery(
    GET_PROJECT_ROLE_REFERENCED_STATUS_IN_PROJECT_RATE_TABLE,
    {
      variables: {
        projectId,
        input: {
          taskUri,
          resourceEstimateSummary,
          roleUri
        }
      },
      skip: !projectId || !taskUri,
      fetchPolicy: 'cache-and-network'
    }
  );

  return {
    projectRoleReferencedInProjectRateTable:
      !loading &&
      data?.project?.getProjectRoleReferencedStatusInProjectRateTable
        ? data?.project?.getProjectRoleReferencedStatusInProjectRateTable
        : null,
    loading
  };
};
